export enum CabinetTypes {
  UacTower = 10,
  UacTowerWithFridge = 11,
  Tower = 12,
  TowerWithFridge = 13,
  Refrigerator = 14,
  Virtual = 15,
  LimitedAccessDrawers = 16,
  VirtualPrintingModule = 17,
  VirtualPrintModuleMini = 18,
  LimitedAccessDrawersDevice = 19,
}
